import {internalLinkToHref} from 'utils';
import {sanityFetch} from 'utils/sanity.fetch';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {FeaturedLinkSchema} from 'components/content-blocks/featured-links/schema';

import {FeaturedLinkRender} from './render';

interface Props {
	featuredLink: FeaturedLinkSchema;
}

export const FeaturedLinkServer = async ({featuredLink}: Props) => {
	const sanityReference = featuredLink.link?.reference;
	if (!sanityReference) {
		return null;
	}

	const reference = await sanityFetch<LinkReferencesQueryResult>({
		query: LINK_REFERENCES_QUERY,
		params: {id: sanityReference._ref},
	});

	return (
		<FeaturedLinkRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={featuredLink.link?.targetBlank}
			text={featuredLink.text}
			title={featuredLink.title}
			tagline={featuredLink.tagline}
			theme={featuredLink.theme}
		/>
	);
};
